import React, { Fragment, useEffect, useState } from 'react';
import { Button, Checkbox, Col, Divider, Row, Tooltip, Typography } from 'antd';
import { UploadedFile } from '../../../../utils';
import { AuthResponse } from '../../../Auth/types';
import { ShareResponse } from '../../../../share';
import {
  CustomButton,
  CustomSelectableTable,
  CustomTabs,
  CustomText,
  CustomTextArea,
  FormInput,
  FormSelect,
  UploadWithTable,
} from '../../../../components';
import { ColumnsType } from 'antd/es/table';
import { AssetsResponse } from '../../../../share/types/asset-response';
import {
  FileTextOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { LocationResponse } from '../../../../share/types/location-response';
import { DateTime } from 'luxon';
import { AnyCnameRecord } from 'dns';
import { useAtom } from 'jotai';
import { dataForCreate } from '../../../../state/atoms';

const { Title } = Typography;

interface RefundCreateViewProps {
  formik: any;
  itemTypes?: ShareResponse[];
  refundStates?: ShareResponse[];
  onCancel: () => void;
  authData?: AuthResponse | null;
  onFiles: (files: UploadedFile[]) => void;
  files?: UploadedFile[];
  assetsActivos?: AssetsResponse[];
  location?: LocationResponse[];
  selectedRowKeys?: React.Key[];
  setSelectedRowKeys?: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleSaveAddition?: (data: any) => void;
  dependenciesById: any;
  modalState?: AnyCnameRecord;
}

const RefundCreateView: React.FC<RefundCreateViewProps> = ({
  formik,
  refundStates,
  authData,
  files,
  onFiles,
  assetsActivos,
  location,
  selectedRowKeys,
  setSelectedRowKeys,
  handleSaveAddition,
  dependenciesById,
  modalState,
  itemTypes,
}) => {
  const [searchText, setSearchText] = useState('');
  const [formData] = useAtom(dataForCreate);
  const handleSelectionChange = (selectedKeys: React.Key[]) => {
    setSelectedRowKeys?.(selectedKeys);
  };
  
  const columnsActivos: ColumnsType<AssetsResponse> = [
    {
      title: 'Item',
      dataIndex: 'id',
      key: 'id',
      render: (item) => (item ? item : 'Sin registro'),
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const val = String(value)?.toLowerCase();
        return String(record.plate_code)?.toLowerCase()?.includes(val) ||
                String(record.description)?.toLowerCase()?.includes(val) ||
                String(record.asset_class?.name)?.toLowerCase()?.includes(val) ||
                String(record.asset_class?.code)?.toLowerCase()?.includes(val);
      },
    },
    {
      title: 'Código/placa',
      dataIndex: 'plate_code',
      key: 'plate_code',
      render: (item) => (item ? item : 'Sin registro'),
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      filteredValue: [searchText],
      render: (item) => (item ? item : 'Sin registro'),
    },
    {
      title: 'Clase de activo',
      dataIndex: 'asset_class',
      key: 'asset_class',
      render: (item) => {
        return item.name ? `${item.code} - ${item.name}` : 'Sin registro';
      },
    },
    {
      title: 'Artículo',
      dataIndex: 'item',
      key: 'item',
      render: (item) => {
        return item.name ? `${item.code} - ${item.name}` : 'Sin registro';
      },
    },
    {
      title: 'Adiciones',
      dataIndex: 'assets',
      key: 'assets',
      render: (item) => (item && item.length > 0 ? item.length : '0'),
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (_: any, record) => {
        return (
          <>
            <Tooltip title="Ver solicitud">
              <CustomButton
                label="Ver adiciones"
                onClick={() => handleSaveAddition?.(record)}
                size="middle"
                disabled={
                  record.assets && record.assets.length > 0 ? false : true
                }
              />
            </Tooltip>
          </>
        );
      },
    },
  ];
  useEffect(() => {
    if (dependenciesById && dependenciesById.length > 0) {
      formik.setFieldValue('dependency_id', dependenciesById[0].id);
    }
    formik.setFieldValue('refounds_type', 1);
    
  }, [modalState, dependenciesById]);

  useEffect(() => {
    const idsAssets: number[] = formData?.id_items ?? [Number(formData?.item?.id)];
    handleSelectionChange(idsAssets);
  }, []);
  const [filteredData, setFilteredData] = useState<AssetsResponse[]>([]);

useEffect(() => {
  if (assetsActivos) {
    setFilteredData(assetsActivos);
  }
}, [assetsActivos]);


const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
  const value = event.target.value;
  setSearchText(value);
};

  return (
    <Fragment>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Solicitante"
            name="requester_id"
            placeholder="Solicitante"
            value={`${authData?.user.document} - ${authData?.user.name} ${authData?.user.last_name} `}
            disabled
            error={formik.errors.requester_id}
            touched={formik.touched.requester_id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Fecha de solicitud"
            name="initial_date"
            placeholder="Solicitante"
            value={DateTime.now().toFormat('yyyy-MM-dd')}
            disabled
            error={formik.errors.initial_date}
            touched={formik.touched.initial_date}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Dependencia"
            name="dependency_id"
            placeholder="Seleccione"
            value={formik.values.dependency_id}
            options={dependenciesById}
            error={formik.errors.dependency_id}
            touched={formik.touched.dependency_id}
            onChange={(value) => formik.setFieldValue('dependency_id', value)}
            onBlur={formik.handleBlur}
            disabled
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Ubicación"
            name="location_id"
            placeholder="Seleccione"
            value={formik.values.location_id}
            options={location?.map((x) => ({
              name: x.name + ' / ' + x.city?.name,
              id: x.id.toString(),
            }))}
            error={formik.errors.location_id}
            touched={formik.touched.location_id}
            onChange={(value) => formik.setFieldValue('location_id', value)}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6} className="input-disable">
          <FormSelect
            label="Estado solicitud"
            name="status_id"
            placeholder="Seleccione"
            value={formik.values.status_id}
            options={refundStates}
            disabled={true}
            error={formik.errors.status_id}
            touched={formik.touched.status_id}
            onChange={(value) => formik.setFieldValue('status_id', value)}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Tipo de solicitud"
            name="refounds_type"
            placeholder="Seleccione el tipo de solicitud"
            value={formik.values.refounds_type}
            options={itemTypes?.filter((item) => item.name === 'Activo fijo')}
            error={formik.errors.refounds_type}
            touched={formik.touched.refounds_type}
            onChange={(value) => {
              setSelectedRowKeys?.([]);
              formik.setFieldValue('refounds_type', value);
            }}
            onBlur={formik.handleBlur}
            disabled
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <CustomTextArea
            label="Observaciones (opcional)"
            name="observations"
            placeholder="Describa"
            value={formik.values.observations}
            error={formik.errors.observations}
            touched={formik.touched.observations}
            onChange={(value) =>
              formik.setFieldValue('observations', value.target.value)
            }
            onBlur={formik.handleBlur}
            maxLength={501}
          />
        </Col>
      </Row>
      <Col xs={24} sm={12} style={{ textAlign: 'right' }}>
              <FormInput
                label="Buscador"
                placeholder="Buscar..."
                value={searchText}
                onChange={handleSearch}
                name="search"
              />
            </Col>
      <Divider />
      {true ||
      formik.values.refounds_type === 2 ? (
        <>
          <CustomText
            fontSize="big"
            text={
              true
                ? 'Listado de activos'
                : 'Bienes de consumo'
            }
          />
          <CustomTabs
            defaultActiveKey="1"
            items={[
              {
                key: '1',
                label: (
                  <Button type="link" icon={<UnorderedListOutlined />}>
                    Items
                  </Button>
                ),
                children: (
                  <Fragment>
                  <Row justify="space-between" align="middle" className="mb-3 ml-1 pb-1">
                  <Col>
                    <Checkbox
                      indeterminate={
                        !!selectedRowKeys &&
                        !!assetsActivos &&
                        selectedRowKeys.length > 0 &&
                        selectedRowKeys.length < assetsActivos.length
                      }
                      checked={
                        !!selectedRowKeys &&
                        !!assetsActivos &&
                        selectedRowKeys.length === assetsActivos.length
                      }
                      onChange={(e) => {
                        if (!setSelectedRowKeys || !assetsActivos) return;

                        if (e.target.checked) {
                          const allKeys = assetsActivos.map((item) => item.id);
                          setSelectedRowKeys(allKeys);
                          handleSelectionChange(allKeys);
                        } else {
                          setSelectedRowKeys([]);
                          handleSelectionChange([]);
                        }
                      }}
                    >
                      Seleccionar todos
                    </Checkbox>
                  </Col>
                </Row>
                    <Row gutter={[16, 16]} justify="end">
                      <Col xs={24} sm={24} md={24} lg={24}>
                        {true && (
                          <CustomSelectableTable<AssetsResponse>
                            dataSource={filteredData}
                            columns={columnsActivos}
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                            rowSelection={{
                              selectedRowKeys,
                              onChange: handleSelectionChange,
                            }}
                          />
                        )}
                        {/* {formik.values.refounds_type === 2 && (
                          <CustomSelectableTable<AssetsResponse>
                            dataSource={assetsConsumos}
                            columns={columnsConsumo}
                            rowKey="id"
                            scroll={{ x: 'max-content' }}
                            rowSelection={{
                              selectedRowKeys,
                              onChange: handleSelectionChange,
                            }}
                          />
                        )} */}
                      </Col>
                    </Row>
                  </Fragment>
                ),
              },
              {
                key: '2',
                label: (
                  <Button type="link" icon={<FileTextOutlined />}>
                    Documentos
                  </Button>
                ),
                children: (
                  <>
                    <Title
                      level={4}
                      style={{ textAlign: 'center', marginBottom: '20px' }}
                    >
                      Documentos cargados
                    </Title>
                    <Row>
                      <Col xs={24}>
                        <UploadWithTable
                          onFilesChange={onFiles}
                          files={files}
                        />
                      </Col>
                    </Row>
                  </>
                ),
              },
            ]}
          />
        </>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default RefundCreateView;
